<template>
    <div v-if="section.is_active">
        <h2 class="text-28 lg:text-36 text-navy font-bold mt-10 mb-2" id="video_advertising">Video Advertising</h2>
        <div class="hidden lg:flex relative">
            <img 
                src="/proposal-presentation-files/img/hammer-ads.png" 
                alt="Hammer video" 
                class="absolute -top-6 z-10 right-10 duration-500 hover:scale-110 cursor-pointer" 
                style="max-height: 275px"
                @click="enlargeImage"
            >
        </div>
        <div class="bg-white shadow p-6 lg:p-8 tr-box lg:mt-4 lg:mb-20">
            <div class="flex flex-col justify-start gap-y-4 lg:w-1/2 mb-8 lg:mb-0">
                <div>
                    <img src="/proposal-presentation-files/img/hammer-logo.png" alt="Hammer app logo" style="max-height: 51px">
                </div>
                <div v-html="bullets.video_advertising_hammer"></div>
            </div>
        </div>
        <div class="flex lg:hidden justify-center my-4">
            <img 
                src="/proposal-presentation-files/img/hammer-ads.png" 
                alt="Hammer video" 
                class="-mt-12 cursor-pointer" 
                style="max-height: 275px"
                @click="enlargeImage"
            >
        </div>

        <div class="hidden lg:flex relative">
            <img 
                src="/proposal-presentation-files/img/truckers-ads.png" 
                alt="TruckersReport ads" 
                class="absolute -top-2 z-10 left-10 duration-500 hover:scale-110 cursor-pointer" 
                style="max-height: 240px"
                @click="enlargeImage"
            >
        </div>
        <div class="bg-white shadow p-6 lg:p-8 tr-box mt-8 lg:mt-4 lg:mb-24 flex justify-end">
            <div class="flex flex-col justify-start gap-y-4 lg:w-3/5 mb-8 lg:mb-0">
                <div>
                    <img src="https://www.thetruckersreport.com/wordpress/wp-content/themes/truckersreport/images/tr-logo.svg" alt="TruckersReport.com logo" style="height: 42px">
                </div>
                <div v-html="bullets.video_advertising_truckersreport"></div>
            </div>
        </div>
        <div class="flex lg:hidden justify-center my-4">
            <img 
                src="/proposal-presentation-files/img/truckers-ads.png" 
                alt="TruckersReport ads" 
                class="-mt-12 cursor-pointer" 
                style="max-height: 240px"
                @click="enlargeImage"
            >
        </div>

        <proposal-modal-image
            v-if="modalImage"
            :modal-image-url="modalImageUrl"
            :modal-image-container="modalImageContainer"
            @close="modalImage = false"
        />
    </div>
</template>

<script>
import ProposalModalImage from "./proposal-modal-image";
import sellingPointMixin from '../sellingPointMixin';

export default {
    components: {
        ProposalModalImage,
    },
    mixins: [
        sellingPointMixin
    ],
    props: [
        'section',
    ],
    computed: {
        bullets() {
            return {
                video_advertising_hammer: this.section.content_hammer,
                video_advertising_truckersreport: this.section.content_truckersreport,
            }
        },
    },
}
</script>